var app = angular.module('directives.counter');

app.directive('counter', ['PortalApi', 'Notification',  '$compile',
    function(PortalApi, Notification, $compile) {
        return {

            restrict: 'E',
            scope:{
                counterName: '='
            },
            template: require('../templates/counter.html'),
            link: postLink
        };

        function postLink($scope, el, attrs, controller) {
            var num = 0;
            var nowDate = new Date();

            if (attrs.counterName == 'clientsOnline') {
                var min = 0;
                var max = 0;
                var hour = nowDate.getHours();

                if (hour >= 1 && hour < 7) {
                    min = 5;
                    max = 73;
                } else if (hour >= 7 && hour < 9) {
                    min = 92;
                    max = 239;
                } else if (hour >= 7 && hour < 9) {
                    min = 157;
                    max = 458;
                } else if (hour >= 9 && hour < 20) {
                    min = 245;
                    max = 419;
                } else if (hour >= 20 && hour < 22) {
                    min = 153;
                    max = 341;
                } else {
                    min = 38;
                    max = 117;
                }

                num = Math.random() * (max - min) + min;

            } else if (attrs.counterName == 'payments') {
                num = (+new Date() - 1469998800000) / (1000 * 60) * 3;

            } else if (attrs.counterName == 'services') {
                num = ((+new Date() - 1469998800000) / (1000 * 60 * 60 * 10)) + 1007;
            }

            var countValue = Math.floor(num);
            $scope.count = countValue.toString();
            
            if ($scope.$parent) {
                if (attrs.counterName == 'clientsOnline') {
                    $scope.$parent.clientsCount = countValue;
                    $scope.$parent.clientsAriaLabel = countValue + ' клієнтів здійснюють оплату зараз';
                } else if (attrs.counterName == 'payments') {
                    $scope.$parent.paymentsCount = countValue;
                    $scope.$parent.paymentsAriaLabel = countValue + ' рахунків сплачено клієнтами PayHub';
                } else if (attrs.counterName == 'services') {
                    $scope.$parent.servicesCount = countValue;
                    $scope.$parent.servicesAriaLabel = countValue + ' компаній доступні для сплати';
                }
            }
        }
    }
]);

module.exports = 'directives.counter';



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/counter/directives/counter.js
 ** module id = 151
 ** module chunks = 1
 **/